import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { PURCHASEIRQCompareView } from "../views/PURCHASEIRQCompareView";
import { purchaseComparePageValidationSchema } from "../util/comparePageValidationSchema";
import { connect } from "react-redux";
import { mapPageToProps } from "../util/mapPageToProps";
import { isDataValidForPurchaseOrBuild } from "../util/fetch/isDataValidForPurchaseOrBuild";
import { LoadingIndicator } from "../atoms/LoadingIndicator";
import { FastTrackView } from "../views/FastTrackView";
import { processQuoteResult } from "../util/fetch/processQuoteResult";
import { withToastContext } from "../util/withToastContext";
import { isPlannedClosingDateLessThanThirteenDaysAway } from "../util/fetch/isPlannedClosingDateLessThanThirteenDaysAway";
import { getParametizedQuoteEndpoint } from "../util/fetch/getParametizedQuoteEndpoint";
import { LookingToContext } from "../context/LookingToContext";
import StatusCheck from "../components/StatusCheck";
import { CountyLimitsContext } from "../context/CountyLimitsContext";

class BuildIrqComparePage extends Component {
  static contextType = CountyLimitsContext;

  constructor() {
    super();
    this.state = {
      quotes: null,
      insufficientData: null,
      lookingTo: "Build",
    };
    this.runQuotesQuery = this.runQuotesQuery.bind(this);
    this.getPageData = this.getPageData.bind(this);
  }

  componentDidMount() {
    if (!isDataValidForPurchaseOrBuild(this.props.data)) {
      this.setState({ insufficientData: true });
      if (
        isPlannedClosingDateLessThanThirteenDaysAway(
          this.props.data.plannedClosingDate
        )
      ) {
        this.props.toastContext.openToast({
          message:
            "You must select a planned closing date more than 15 days away.",
        });
      }
      this.context.fetchCountyLimits();
      return;
    }
    this.getPageData();
  }

  getPageData = async () => {
    await this.context.fetchCountyLimits();
    this.runQuotesQuery(this.props.data.lookingTo ?? "Build", this.props.data);
  };

  runQuotesQuery = (lookingTo, data) => {
    this.setState({ lookingTo });
    const parametizedQuoteEndpoint = getParametizedQuoteEndpoint(
      lookingTo,
      data
    );
    return processQuoteResult.call(this, parametizedQuoteEndpoint);
  };

  render() {
    const { countyLimits } = this.context;

    if (countyLimits === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching page data..." />
        </div>
      );
    }

    if (this.state.insufficientData === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching loan options..." />
        </div>
      );
    }

    if (this.state.insufficientData === true) {
      return (
        <div className="page-wrapper">
          <StatusCheck />
          <LookingToContext.Provider value={this.state.lookingTo}>
            <EditableDataContainer
              id="buildIrq"
              mutateRedux="always"
              validationSchema={purchaseComparePageValidationSchema}
              isStep
            >
              <FastTrackView
                lookingTo={this.state.lookingTo}
                runQuotesQuery={this.runQuotesQuery}
                content={contentMap.BuildIrqComparePage}
                navigationsAway={customNavigationMap.BuildIrqComparePage}
              />
            </EditableDataContainer>
          </LookingToContext.Provider>
        </div>
      );
    }

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <LookingToContext.Provider value={this.state.lookingTo}>
          <EditableDataContainer
            id="buildIrq"
            mutateRedux="always"
            isStep
            validationSchema={purchaseComparePageValidationSchema}
          >
            <PURCHASEIRQCompareView
              lookingTo={this.state.lookingTo}
              runQuotesQuery={this.runQuotesQuery}
              quotes={this.state.quotes}
              content={contentMap.BuildIrqComparePage}
              navigationsAway={customNavigationMap.BuildIrqComparePage}
            />
          </EditableDataContainer>
        </LookingToContext.Provider>
      </div>
    );
  }
}

export default connect(mapPageToProps("buildIrq"))(
  withToastContext(withRouterUtilities(BuildIrqComparePage))
);
